var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileProfileReel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13 0a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5zm3.457 5.657H1.542v7.8a3 3 0 0 0 2.825 2.995l.176.005h8.914a3 3 0 0 0 3-3zM7.686 7.952a1 1 0 0 1 .508.14l2.692 1.59a1 1 0 0 1 0 1.722l-2.692 1.59a1 1 0 0 1-1.508-.86V8.951a1 1 0 0 1 1-1m-3.147-6.41a3 3 0 0 0-2.966 2.572h4.45Zm5.141 0H6.319l1.486 2.572h3.36zm3.777 0h-1.995l1.486 2.572h3.479a3 3 0 0 0-2.794-2.566z"
})));
export default SvgInstagramMobileProfileReel;